import { Component, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { RouteEnum } from "../../shared/models/routes.model";
import { ServiceMetaData } from "../../shared/models/service-meta.model";
import { PaginationParams, DataElement } from "../../shared/models/common";
import {
  ClinicsSearchParams,
  Clinic,
  ClinicSearchParams,
} from "src/app/shared/models/clinic.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { Store } from "@ngrx/store";
import {
  clinicsDetails,
  clinicsSearchMetadata,
} from "src/app/shared/ngrx/ngrx-selectors";
import { RUN_CLINICS_SEARCH } from "src/app/shared/ngrx/ngrx-actions";
import { ClinicFiltersComponent } from "./clinic-filters/clinic-filters.component";
import { ClinicListComponent } from "./clinic-list/clinic-list.component";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { CommonModule } from "@angular/common";
import { EditClinicComponent } from "./edit-clinic/edit-clinic.component";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-mng-clinics",
  templateUrl: "./mng-clinics.component.html",

  imports: [
    ClinicFiltersComponent,
    ClinicListComponent,
    ModalPopupComponent,
    CommonModule,
    EditClinicComponent,
    LoaderComponent,
    TranslateModule,
  ],
  standalone: true,
})
export class MngClinicsComponent implements OnInit {
  searchSubscription: Subscription;
  selectedClinic: Clinic;
  editClinicPanelDisplay: boolean;

  clinicsLoading: boolean;
  numberOfRows: number = 10;
  rangeFrom: number = 1;
  rangeTo: number = this.numberOfRows;
  totalRecords: number;

  get displayClinics(): Clinic[] {
    return this.store.selectSignal(clinicsDetails)();
  }

  get clinicsSearchMetaData(): ServiceMetaData {
    return this.store.selectSignal(clinicsSearchMetadata)() || {};
  }

  searchParams: ClinicSearchParams = {
    rangeTo: this.rangeTo,
    rangeFrom: this.rangeFrom,
    searchId: null,
  };

  constructor(
    private readonly store: Store,
    private broshService: BroshService
  ) {}

  ngOnInit(): void {
    this.runClinicsSearch(true);
  }

  runClinicsSearch(newSearch: boolean) {
    this.clinicsLoading = true;

    var element = document.getElementById("clinicSearch");
    if (element) element.scrollIntoView(true);

    this.store.dispatch(
      RUN_CLINICS_SEARCH({
        newSearch: newSearch,
      })
    );

    this.broshService.getClinicDetails(this.searchParams).subscribe(
      () => {
        this.clinicsLoading = false;
      },
      () => (this.clinicsLoading = false)
    );
  }

  getClinicsBySearch(params: ClinicsSearchParams) {
    console.log(params);
    this.searchParams = Object.assign(
      this.searchParams,
      this.store.selectSignal(clinicsSearchMetadata)(),
      params
    );

    this.searchParams.rangeFrom = 1;
    this.searchParams.rangeTo = this.numberOfRows;
    this.searchParams.searchId = null;

    this.runClinicsSearch(true);
  }

  loadDataOnPagination(event: any) {
    if (
      !this.displayClinics ||
      (event.rangeFrom == this.searchParams.rangeFrom &&
        event.rangeTo == this.searchParams.rangeTo)
    )
      return;

    this.searchParams.rangeFrom = event.rangeFrom;
    this.searchParams.rangeTo = event.rangeTo;
    this.searchParams.searchId = this.store.selectSignal(
      clinicsSearchMetadata
    )().searchId;

    this.runClinicsSearch(false);
  }
}
